import React from "react";
import "./RO.css";
import { BeakerIcon, BuildingOfficeIcon, CpuChipIcon } from "@heroicons/react/24/outline";
import { Link } from "react-router-dom";  

export default function SkidMountedROPage() {
  return (
    <main className="ro-page">

      {/* Hero Section */}
      <section className="hero-ro" style={{background:"url('/images/RO.png')"}}>
        <div className="hero-ro-overlay">
            <div className="hero-ro-text">
            <h1>Skid Mounted Reverse Osmosis System</h1>
            <p>
                Compact, efficient, and reliable reverse osmosis solutions designed for industrial and
                commercial water treatment.
            </p>
           <Link to="/contact"> <button className="cta-btn">Request a Quote</button></Link>
            </div>
        </div>
        </section>

      {/* Intro Section */}
      <section className="description-ro">
        <div className="desc-ro-container">
            {/* Text Block */}
            <div className="desc-ro-text">
            <h2>Efficiency Meets Reliability in Skid Mounted RO</h2>
            <p>
                Reverse Osmosis is a water purification technology that uses a semi-permeable membrane to remove ions, molecules, and large particles from drinking water.
            </p>
            <p>Crystal Drops offers a series of RO systems which are highly efficient,
               reliable and cost effective in removing total dissolved salts from the water 
                and provide ultrapure water for variety of appliactions.
            </p>
            <p>Crystal Drops RO systems are designed to cater for both domestic and industrial use.</p>
            </div>

            {/* Image Block */}
            <div className="desc-ro-image">
            <img src="/images/RO-1.png" alt="Skid Mounted RO System in operation" />
            </div>
        </div>
        </section>

      {/* Applications Section */}

<section className="ro-applications-grid">
  <h2>Applications</h2>
  <div className="ro-grid-container">
    {[
      {
        icon: <BeakerIcon className="icon" />, // Mineral Water
        title: "Mineral Water",
        desc: "Produces high-quality mineral water by removing impurities and ensuring taste consistency.",
      },
      {
        icon: <BuildingOfficeIcon className="icon" />, // Manufacturing
        title: "Processed Water for Manufacturing",
        desc: "Provides consistent water quality for food, beverage, and industrial production processes.",
      },
      {
        icon: <CpuChipIcon className="icon" />, // Pharma & Electronics
        title: "Ultrapure Water for Pharma & Electronics",
        desc: "Delivers ultrapure water essential for pharmaceutical formulations and sensitive electronic manufacturing.",
      },
    ].map((app, i) => (
      <div key={i} className="ro-app-card">
        <div className="icon-wrap">{app.icon}</div>
        <h3>{app.title}</h3>
        <p>{app.desc}</p>
      </div>
    ))}
  </div>
</section>

      {/* Advantages Section - Timeline */}
      <section className="ro-advantages">
  <h2>Advantages</h2>
  <div className="ro-adv-timeline">
    {[
      {
        id: 1,
        title: "Reliable Water Quality",
        desc: "Consistent output compared to conventional De-Mineralisation systems.",
      },
      {
        id: 2,
        title: "Cost Efficiency",
        desc: "Low operating and maintenance cost.",
      },
      {
        id: 3,
        title: "Ease of Use",
        desc: "Simple installation, operation, and maintenance.",
      },
      {
        id: 4,
        title: "Flexible Capacities",
        desc: "Available in various sizes to suit end user requirements.",
      },
    ].map((step) => (
      <div className="ro-adv-milestone" key={step.id}>
        <span className="ro-step-marker">{step.id}</span>
        <h3>{step.title}</h3>
        <p>{step.desc}</p>
      </div>
    ))}
  </div>
</section>

      {/* CTA Section */}
      <section className="ro-cta">
  <div className="ro-cta-content">
    <h2>Ready to Install a Skid Mounted RO System?</h2>
    <p>
      Contact us today to discuss your requirements and get a customized solution
      tailored to your facility.
    </p>
    <div className="ro-cta-actions">
      <Link to="/contact"><button className="ro-btn-primary">Request Consultation</button></Link>
      <a href="/Brochure.pdf" download className="ro-btn-secondary">Download Brochure</a>
    </div>
  </div>
</section>

    </main>
  );
}